import {
  Box,
  Button,
  Modal,
  SpaceBetween,
  TextContent,
} from "@cloudscape-design/components-themed";
import { GroupedMerchantAddress } from "../../../features/api-interfaces";
import { COMMON_LABELS } from "../../default-constants";
import {
  ADDRESS_APP,
  ADDRESS_OTHER_LABEL,
  ADDRESS_TAX,
  ADDRESS_TSR,
  LABELS,
} from "../constants";
import { getAddress } from "../util";
import { AddressInfoContent } from "./AddressInfo";

interface IAddressInfoDetailModal {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  addressList: GroupedMerchantAddress[];
}

/**
 * 申請事業者住所モーダル
 */
export const AddressInfoDetailModal = (props: IAddressInfoDetailModal) => {
  const { visible, setVisible, addressList } = props;
  const hasMultipleAddresses = 1 < addressList?.length;
  const tsrAddress = getAddress(addressList, Number(ADDRESS_TSR.value));
  const taxAddress = getAddress(addressList, Number(ADDRESS_TAX.value));
  const otherAddress = getAddress(addressList, Number(ADDRESS_APP.value));

  return (
    <Modal
      onDismiss={() => setVisible(false)}
      visible={visible}
      size={"large"}
      footer={
        <Box float={"right"}>
          <Button variant={"normal"} onClick={() => setVisible(false)}>
            {COMMON_LABELS.BTNS.CLOSE}
          </Button>
        </Box>
      }
      header={LABELS.APPLICATION_INFO_TITLE}
    >
      <SpaceBetween size={"xxl"} direction={"vertical"}>
        {hasMultipleAddresses && (
          <Box>
            <TextContent>
              <h5>{LABELS.APPLICATION_COMPANY_SUB_TITLE}</h5>
            </TextContent>
          </Box>
        )}
        {tsrAddress && (
          <AddressInfoContent
            title={ADDRESS_TSR.label}
            addressInfo={tsrAddress}
          />
        )}
        {taxAddress && (
          <AddressInfoContent
            title={ADDRESS_TAX.label}
            addressInfo={taxAddress}
          />
        )}
        {otherAddress && (
          <AddressInfoContent
            title={ADDRESS_OTHER_LABEL}
            addressInfo={otherAddress}
          />
        )}
      </SpaceBetween>
    </Modal>
  );
};
